__turbopack_context__.v({
  "aspectBox": "Hero-module-scss-module__-rX89G__aspectBox",
  "category": "Hero-module-scss-module__-rX89G__category",
  "cheese": "Hero-module-scss-module__-rX89G__cheese",
  "cta": "Hero-module-scss-module__-rX89G__cta",
  "fade-in": "Hero-module-scss-module__-rX89G__fade-in",
  "fade-up": "Hero-module-scss-module__-rX89G__fade-up",
  "headingGroup": "Hero-module-scss-module__-rX89G__headingGroup",
  "hero": "Hero-module-scss-module__-rX89G__hero",
  "heroImage": "Hero-module-scss-module__-rX89G__heroImage",
  "heroImageTop": "Hero-module-scss-module__-rX89G__heroImageTop",
  "hidden": "Hero-module-scss-module__-rX89G__hidden",
  "image": "Hero-module-scss-module__-rX89G__image",
  "inner": "Hero-module-scss-module__-rX89G__inner",
  "leftHand": "Hero-module-scss-module__-rX89G__leftHand",
  "link": "Hero-module-scss-module__-rX89G__link",
  "linkIcon": "Hero-module-scss-module__-rX89G__linkIcon",
  "linkText": "Hero-module-scss-module__-rX89G__linkText",
  "move-cheese-horizontal": "Hero-module-scss-module__-rX89G__move-cheese-horizontal",
  "move-cheese-vertical": "Hero-module-scss-module__-rX89G__move-cheese-vertical",
  "move-hand-vertical": "Hero-module-scss-module__-rX89G__move-hand-vertical",
  "move-left-hand-horizontal": "Hero-module-scss-module__-rX89G__move-left-hand-horizontal",
  "move-right-hand-horizontal": "Hero-module-scss-module__-rX89G__move-right-hand-horizontal",
  "nav": "Hero-module-scss-module__-rX89G__nav",
  "productGrid": "Hero-module-scss-module__-rX89G__productGrid",
  "rightHand": "Hero-module-scss-module__-rX89G__rightHand",
  "root": "Hero-module-scss-module__-rX89G__root",
  "showIntro": "Hero-module-scss-module__-rX89G__showIntro",
  "title": "Hero-module-scss-module__-rX89G__title",
  "titleMark": "Hero-module-scss-module__-rX89G__titleMark",
  "up": "Hero-module-scss-module__-rX89G__up",
});
